import styled from '@emotion/styled'
import { DoseDispensingProductsListItemDto } from '@pharmac-extranet/extranet-api'
import { PharmacIcon } from '@pharmac/ui'
import { useTranslation } from 'react-i18next'
import { CatalogItemIcon } from './CatalogItemIcon'

type Props = {
  halving: DoseDispensingProductsListItemDto['halving']
}

export const AlwaysHalvedIcon = styled(PharmacIcon)`
  background: conic-gradient(
    transparent 0deg,
    transparent 90deg,
    transparent 90deg,
    transparent 180deg,
    #88288f 180deg,
    #88288f 270deg,
    #88288f 270deg
  );
  transform: rotate(-135deg);
  color: transparent;
  border: 1px solid var(--color-purple);
  border-radius: 50%;
  height: 50%;
`

export const HalvableIcon = styled(PharmacIcon)`
  color: white;
  background: #88288f;
  border-radius: 50%;
  transform: rotate(-45deg);
`

export const CatalogItemHalving = ({ halving }: Props) => {
  const { t } = useTranslation()

  return (
    <CatalogItemIcon>
      {halving === 'No' && ''}
      {halving === 'Yes' && (
        <>
          <HalvableIcon icon="minus" />
          <span>{t('medicines.halvable')}</span>
        </>
      )}
      {halving === 'Always' && (
        <>
          <AlwaysHalvedIcon icon="circle" />
          <span>{t('medicines.alwaysHalvable')}</span>
        </>
      )}
    </CatalogItemIcon>
  )
}
